import actions from "./actions";

export default {
  namespaced: true,
  state: {
    profile: null,
    activeSession: [],
    isTestRole: false,
    dataLoading: false,
    checkProfile: 0,
    systemWallet: ""
  },
  getters: {
    systemWallet: state => {
      return state.systemWallet;
    },

    profile: state => {
      return state.profile;
    },

    activeSession: state => {
      return state.activeSession;
    },

    checkProfile: state => {
      return state.checkProfile;
    },

    dataLoading: state => {
      return state.dataLoading;
    },

    isTestRole: state => {
      return state.isTestRole;
    }
  },
  mutations: {
    setSystemWallet(state, value) {
      state.systemWallet = value;
    },

    setProfile(state, value) {
      state.profile = value;
    },

    setActiveSession(state, value) {
      state.activeSession = value;
    },

    setCheckProfile(state, value) {
      state.checkProfile = value;
    },

    setDataLoading(state, dataLoading) {
      state.dataLoading = dataLoading;
    },

    setTestRole(state, isTestRole) {
      state.isTestRole = isTestRole;
    }
  },
  actions
};